import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Header, Footer, SkipNavLink } from 'components'
import { scrollToTop } from 'utils'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function Layout({ children }) {
  const { pathname } = useLocation()

  // Scroll to top of page when route changes
  useEffect(() => {
    scrollToTop()
  }, [pathname])

  return (
    <div>
      <SkipNavLink targetId="main-content">Skip to main content</SkipNavLink>
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  )
}

Layout.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout)
